import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100" style={{ background: "#fff" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Our <span>Construction Software Development</span> Services
            </h2>
            <p>
              The construction industry is evolving at a breakneck pace, and
              your business must keep up. Our construction software development
              services help you to transform challenges into opportunities for
              growth and scalability.
            </p>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Software Development Consulting</h4>
                  <p>
                    We provide expert guidance to identify technology needs and
                    craft tailored software strategies for efficient project
                    execution.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Custom Software Development</h4>
                  <p>
                    Get your fully tailored software solutions designed to
                    enhance efficiency and control in construction management.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Web/Mobile Application Development</h4>
                  <p>
                    We develop custom web and mobile apps for managing on-site
                    operations and ensuring seamless team communication.
                  </p>
                </div>

                <div className="robust-content">
                  <h4>Enterprise Construction Software Development</h4>
                  <p>
                    Tekrevol is the preferred choice for large-scale,
                    enterprise-grade solutions that optimize resource planning
                    and project management for complex projects.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>API Development & Integration</h4>
                  <p>
                    Our API development services ensure seamless integration
                    between existing systems and new software solutions to
                    improve data flow and operational efficiency.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Custom Cloud Migration Services</h4>
                  <p>
                    Cloud experts at Tekrevol facilitate cloud migration of your
                    construction software to centralize data, enhancing
                    accessibility and real-time project management.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Legacy System Modernization</h4>
                  <p>
                    Expert teams at Tekrevol help you upgrade outdated software
                    to enhance performance, security, and scalability for modern
                    project demands.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Integration & Customization</h4>
                  <p>
                    Bespoke integration and customization of off-the-shelf
                    software help construction companies like yours to meet the
                    challenges of their specific business processes.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Post-Development Support</h4>
                  <p>
                    We provide ongoing technical support and system upgrades for
                    your custom solutions to ensure smooth operation and
                    adaptability to business needs.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
